import React from 'react';
import { LineChart, Line, PieChart as RePieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { BarChart3, PieChart } from 'lucide-react';
import { formatCurrency } from '../../lib/formatters';

const PortfolioCharts = ({
  filteredDeals,
  metrics,
  getCollectionTrendsData,
  renderCustomPieLabel
}) => {
  const getStatusPieData = () => {
    const colorMap = {
      'Funded': '#10b981',
      'Payment Issues': '#f59e0b',
      'In-House Collection': '#f97316',
      'Default': '#ef4444',
      'Collected': '#3b82f6',
      'Paid in Full': '#8b5cf6'
    };
    
    return Object.entries(metrics.statusCounts || {})
      .filter(([status, count]) => count > 0)
      .map(([status, count]) => ({
        name: status,
        value: count,
        color: colorMap[status] || '#6b7280'
      }));
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
      {/* Collection Trends Chart */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <BarChart3 className="h-5 w-5 mr-2" />
            Collection Trends
          </CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={getCollectionTrendsData()}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip formatter={(value) => formatCurrency(value)} />
              <Legend />
              <Line type="monotone" dataKey="funded" stroke="#3b82f6" name="Funded" strokeWidth={2} />
              <Line type="monotone" dataKey="collected" stroke="#10b981" name="Collected" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      {/* Status Distribution Chart */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <PieChart className="h-5 w-5 mr-2" />
            Deal Status Distribution
          </CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={300}>
            <RePieChart>
              <Pie
                data={getStatusPieData()}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={renderCustomPieLabel}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
              >
                {getStatusPieData().map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip />
            </RePieChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </div>
  );
};

export default PortfolioCharts;
